// user-agent判定
var ua = navigator.userAgent;
//iPhone向け処理
if (ua.indexOf('Android') > 0) {
	$(function() {
		$('.download-link').addClass('js-device-android');
	});
}